import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "camera-item",
  style: {"width":"100px"}
}
const _hoisted_2 = {
  key: 0,
  class: "camera-item__record"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraStatusBrief = _resolveComponent("CameraStatusBrief")!
  const _component_CameraScreenshot = _resolveComponent("CameraScreenshot")!
  const _component_CameraStatusInfo = _resolveComponent("CameraStatusInfo")!

  return (_openBlock(), _createBlock(_component_CameraStatusInfo, { item: _ctx.item }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CameraStatusBrief, {
          class: "camera-item__status",
          color: _ctx.item.health_status.code,
          status: '',
          type: "vertical-line"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["color"]),
        (_ctx.item.stream_settings?.enable_recorder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        _createVNode(_component_CameraScreenshot, {
          class: "camera-item__screenshot",
          "model-value": _ctx.item.screenshot,
          "display-width": "90px",
          width: 90,
          "refresh-on-click": false
        }, null, 8, ["model-value"])
      ])
    ]),
    _: 3
  }, 8, ["item"]))
}